import React from "react";
import {
    Icon,
    Header
} from "semantic-ui-react";

const Links = () => (
    <>
        <Header as="h4">Links</Header>
        <a href="https://github.com/jhamberg" title="GitHub">
            <Icon link name="github" size="large" color="black" />
        </a>
        <a href="https://twitter.com/jhamberg" title="Twitter">
            <Icon link name="twitter" size="large" color="blue" />
        </a>
        <a href="https://linkedin.com/in/jhamberg" title="LinkedIn">
            <Icon link name="linkedin" size="large" color="blue" />
        </a>
        <a href="https://scholar.google.fi/citations?user=qOLiAswAAAAJ" title="Google Scholar">
            <Icon link name="google" size="large" color="black" />
        </a>
    </>
);

export default Links;